import React from 'react';

import { CloseIcon } from '@/shared/assets/icons/close-icon';
import { CloseIconCircle } from '@/shared/assets/icons/close-icon-circle';
import { ClearIconButton } from '@/shared/components/ui/button/clear-button/clear-button.styled';
import { TClearButtonProps } from '@/shared/components/ui/button/clear-button/clear-button.types';

export const ClearButton: React.FC<TClearButtonProps> = ({
  circle,
  ...props
}) => {
  return (
    <ClearIconButton $circle={circle} {...props}>
      {circle ? <CloseIconCircle /> : <CloseIcon />}
    </ClearIconButton>
  );
};
